export default "__VITE_ASSET__374e4bee__"